import { createBaseResourceActions } from '../create-base-resource-actions';
import { OrderServiceLinkageResourceTypeMappings } from '@aa/nest/resource';

const domainSlug = '[ORDER SERVICE LINKAGE]';
export const orderServiceLinkageActions =
  createBaseResourceActions<OrderServiceLinkageResourceTypeMappings>(
    domainSlug,
  );
